import React, { useEffect, useState } from "react";
import { clientId, redirectUri, authority, scopes } from "../../AuthConfig";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import LoadingScreen from "react-loading-screen";
import { MsalProvider, useMsal } from "@azure/msal-react";
const login = (props) => {
  const msalConfig = {
    auth: {
      clientId: clientId,
      redirectUri: redirectUri,
      authority: authority,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);
  const dynamicfn = (content) => {
    toast.error(content, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });

  };

  const MicrosoftLoginButton = () => {
    const { instance } = useMsal();
    const [isLoading, setIsLoading] = useState(false);
    localStorage.setItem("loginCount", "false");
    const isLogin = async (token, name) => {

      try {
        const response = await fetch(
          `${process.env.REACT_APP_WEB_SERVICE_URL}/api/Login/Login?username=${name}`,
          {
            method: "POST",
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (response.status === 200) {
          let userInfo = await response.json();


          if (userInfo) {
            props.dispatch({
              type: "Token",
              value: token,
            });
            props.dispatch({
              type: "userType",
              value: userInfo?.Profile?.UserType,
            });
            props.dispatch({
              type: "userName",
              value: userInfo?.Profile?.Name,
            });
            props.dispatch({
              type: "UserId",
              value: userInfo?.Profile?.Employeeid,
            });
          }
          if (userInfo?.Profile?.EnableGoodsExitDate) {
            sessionStorage.setItem(
              "EnableGoodsExitDate",
              userInfo.Profile.EnableGoodsExitDate
            );
          }
          if (userInfo?.Profile?.Employeeid) {
            const loginCount = localStorage.getItem("loginCount");
            if (loginCount === "false") {
              toast.success("Login successfully.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
              localStorage.setItem("loginCount", "true");
            }
          }


          else {
            console.log("Profile field missing:", userInfo?.Profile);
          }
        }
      } catch (err) {
        console.error("Login Error:", err);
      }
    };

    const handleLogin = async () => {
      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts[0]) {
          try {
            const silentResponse = await msalInstance.acquireTokenSilent({
              scopes: scopes,
              account: accounts[0],
            });

            if (silentResponse) {
              setIsLoading(true);
              isLogin(
                silentResponse.accessToken,
                silentResponse.account.username
              );

              return null;
            }
          } catch (silentError) {
            if (silentError.name === "InteractionRequiredAuthError") {
              await instance.loginRedirect({
                scopes: scopes,
                prompt: "select_account", 
              });
              return null;
            } else {
              setIsLoading(false);
              console.error("Silent authentication error:", silentError);
              dynamicfn("Silent authentication error");
              // toast.error("Silent authentication error", {
              //   position: toast.POSITION.TOP_CENTER,
              //   autoClose: 2000,
              // });
            }
          }
        }

        const loginResponse = await instance.loginRedirect({
          scopes: scopes,
          prompt: "select_account",
        });

      } catch (error) {
        console.error("Error logging in:", error);
      }
    };


    msalInstance.addEventCallback((response) => {
      if (response.eventType === EventType.LOGIN_SUCCESS) {
        setIsLoading(true);
        isLogin(
          response.payload.accessToken,
          response.payload.account.username
        );
      } else if (response.eventType === EventType.LOGIN_FAILURE) {
        dynamicfn("Please login with correct Microsoft credentails");
        // toast.error("Please login with correct Microsoft credentails", {
        //   position: toast.POSITION.TOP_CENTER,
        //   autoClose: 2000,
        // });
      }
    });

    useEffect(() => {
      let isMounted = true;


      const intialLogin = async () => {
        try {
          if (!isLoading && isMounted) {
            await handleLogin();
          }
        } catch (error) {
          console.error("Error during login:", error);
        }
      };

      setTimeout(intialLogin, 1000);

      return () => {
        isMounted = false;
      };
    }, [isLoading, handleLogin]);

    return (
      <LoadingScreen
        loading={isLoading}
        bgColor="#f1f1f1"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={process.env.REACT_APP_ENV + "/assets/images/logo/GGP-logo.png"}
      >

      </LoadingScreen>
    );
  };

  return (
    <MsalProvider instance={msalInstance} scopes={["user.read"]}>
      <MicrosoftLoginButton />
    </MsalProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(login);